import { connect } from "react-redux";
import ExtractedDumpsPage from "./ExtractedDumpsPage";
import { RootState } from "types/store";

const mapState = ({ extractedDumps }: RootState) => ({
    initFilters: extractedDumps.filters
});

export default connect(mapState)(ExtractedDumpsPage); 